import { Play, Timer, Sofa, Baby, BatteryLow, Salad } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/landing/Reveal";
import { BENEFITS } from "@/lib/site";

const ICONS = [Play, Timer, Sofa, Baby, BatteryLow, Salad];

export const Benefits = () => (
  <section id="how-it-works" data-testid="benefits-section" className="py-24 md:py-32 bg-slate-950">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <SectionHeading label="Why it works" title="Built for people who've quit every other program" sub="Most fitness plans fail because they demand too much. This system demands less — so you finally do more." />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {BENEFITS.map((b, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={b.title} delay={0.06 * i}>
              <div data-testid={`benefit-card-${i}`} className="h-full bg-slate-900 rounded-[2rem] p-8 md:p-9 border border-slate-800 shadow-[0_8px_30px_rgb(0,0,0,0.25)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_40px_rgb(0,0,0,0.4)]">
                <div className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-6 ${i % 2 ? "bg-orange-500/15 text-orange-400" : "bg-blue-500/15 text-blue-400"}`}>
                  <Icon size={24} />
                </div>
                <h3 className="font-display text-xl font-bold text-white mb-3">{b.title}</h3>
                <p className="text-sm sm:text-base text-slate-400 leading-relaxed">{b.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
